













































































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { RootState } from "@/store";

// Vue components
import EditClientProfileModal from "@/views/App/Tools/UserManagement/EditClientProfileModal.vue";
import DeleteClientProfileModal from "@/views/App/Tools/UserManagement/DeleteClientProfileModal.vue";
import EditOrganizationProfiles from "@/views/App/Tools/UserManagement/EditOrganizationProfiles.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchClientProfilesCommand } from "@/model/communication/users/FetchClientProfilesCommand";
import { Organization } from "@/model/data/organizations/Organization";
import { DeleteClientProfileReqData } from "@/model/communication/users/DeleteClientProfileReqData";
import { DeleteClientProfileCommand } from "@/model/communication/users/DeleteClientProfileCommand";
import { GetOrganizationsCommand } from "@/model/communication/organizations/GetOrganizationsCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { EditOrganizationProfilesCommand, EditOrganizationProfilesReqData } from "@/model/communication/organizations/EditOrganizationProfilesCommand";

export default Vue.extend({
    components: {
        EditClientProfileModal,
        DeleteClientProfileModal,
        EditOrganizationProfiles,
    },
    data() {
        return {
            profileNameInternalString: "@$",
            loading: false,
            showErrorAlert: false,
            search: "",
            profiles: [],
            availableOrganizations: [],
            showEditProfileDialog: false,
            showDeleteProfileDialog: false,
            profileToEdit: null,
            profileToDelete: null,
            showAddProfilesToTheOrganizationDialog: false,
        };
    },
    props: {
        organization: { type: Object as () => Organization, required: false },
    },
    computed: {
        ...mapState({ authUser: (state: RootState) => state.authMod.currentUser }),
        ...mapGetters(["isUserSuperAdmin"]),

        isUserSuperAdminComp() {
            return this.isUserSuperAdmin;
        },

        isOrganizationManagementEnabled() {
            if (
                this.authUser != null &&
                this.authUser.profile != null &&
                this.authUser.profile.privileges != null &&
                this.authUser.profile.privileges.privilegeName != null &&
                this.authUser.profile.privileges.privilegeName.includes(ClientPrivileges.OrganizationsManagement.privilegeName)
            )
                return true;
            else return false;
        },

        headers() {
            let res = [];
            res.push({ text: this.$t("common.name"), value: "name" });
            if (this.isOrganizationManagementEnabled && !this.organization) res.push({ text: this.$t("user_management.organization"), value: "organizationId", sortable: false });
            res.push({ text: this.$t("user_management.visibility"), value: "visibility", sortable: false });
            res.push({ text: this.$t("organizationsManagement.users"), value: "associatedUsersCount", sortable: false });
            res.push({ text: this.$t("organizationsManagement.externalUsers"), value: "associatedExternalUsersCount", sortable: false });
            if (!this.organization) res.push({ text: this.$t("common.actions"), value: "action", sortable: false });
            return res;
        },
    },
    watch: {
        organization() {
            this.getProfiles();
        },
    },
    methods: {
        openEditProfileDialog(profile: any) {
            this.profileToEdit = profile;
            this.showEditProfileDialog = true;
        },

        openDeleteProfileDialog(profile: any) {
            this.profileToDelete = profile;
            this.showDeleteProfileDialog = true;
        },

        async getProfiles() {
            this.showEditProfileDialog = false;
            this.showDeleteProfileDialog = false;
            this.profileToEdit = null;
            this.profileToDelete = null;
            if (!this.loading) {
                try {
                    this.loading = true;
                    let res = await new FetchClientProfilesCommand().execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.profiles = res.clientProfiles;
                    }
                    this.$emit("getUsers");
                    this.loading = false;
                } catch (error) {
                    console.log("Something went wrong during FetchClientProfilesCommand execution: ", error);
                    this.loading = false;
                }
            }
        },

        async deleteProfile() {
            try {
                this.showDeleteProfileDialog = false;
                const res = await new DeleteClientProfileCommand(new DeleteClientProfileReqData(this.profileToDelete.name)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.getProfiles();
                } else this.showErrorAlert = true;
            } catch (error) {
                console.log("Something went wrong during DeleteClientProfileCommand execution: ", error);
            }
        },

        async getOrganizations() {
            try {
                const res = await new GetOrganizationsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.availableOrganizations = res.organizations;
            } catch (e) {
                console.error("Something went wrong during GetOrganizationsCommand execution: ", e);
            }
        },

        async editOrganizationProfiles(selectedProfile: string[]) {
            try {
                this.showAddProfilesToTheOrganizationDialog = false;
                const res = await new EditOrganizationProfilesCommand(new EditOrganizationProfilesReqData(selectedProfile, this.organization.folderId)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    console.log("this.$emit('getOrganizations');");
                    this.$emit("getOrganizations");
                } else console.error("Something went wrong during editOrganizationProfiles execution: ");
            } catch (error) {
                console.error("Something went wrong during editOrganizationProfiles execution: ", error);
            }
        },
    },
    async mounted() {
        if (this.isOrganizationManagementEnabled) await this.getOrganizations();
        this.getProfiles();
    },
});
